import styled from 'styled-components'
import SimpleLink from '../../components/SimpleLink'

export const BackTo = styled(SimpleLink)`
  align-self: flex-start;
  font-weight: bold;
  margin-bottom: 32px;
`
